/**
 * Planet renders. Hand-authored — like brand.ts, not touched by
 * scripts/extract-assets.py.
 */

import planet1 from './planets/planet-1.webp';
import planet2 from './planets/planet-2.webp';
import planet3 from './planets/planet-3.webp';
import planet4 from './planets/planet-4.webp';
import planet5 from './planets/planet-5.webp';
import planet6 from './planets/planet-6.webp';
import planet7 from './planets/planet-7.webp';
import planet8 from './planets/planet-8.webp';
import planet9 from './planets/planet-9.webp';
import planet10 from './planets/planet-10.webp';

export const PLANET_IMAGES = {
  planet1,
  planet2,
  planet3,
  planet4,
  planet5,
  planet6,
  planet7,
  planet8,
  planet9,
  planet10,
} as const;
